export default __webpack_public_path__ + "static/media/whatsstartupindia.902ed636.svg";